export const FORM_TYPE = {
	single: 'single',
	multiple: 'multiple',
	insurance: 'insurance',
};
